import { render, staticRenderFns } from "./UnitServiceOrdersPage.vue?vue&type=template&id=515ed962&"
import script from "./UnitServiceOrdersPage.vue?vue&type=script&lang=js&"
export * from "./UnitServiceOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports